/* ── ExceptionalFire — Gas-Logs interactive Buying Guide ──────────────────────
   A short tap-through quiz (front width → firebox depth → chimney → control) that
   recommends the right LOG SIZE, VENT TYPE and IGNITION using Real Fyre's official
   2 & 3 Burner spec chart, then applies them to the configurator.
   Reads window.EF_GUIDE (available sizes + vent flag) + the live ignition cards. */
(function () {
  var btn = document.getElementById('efOfGuideBtn');
  var modal = document.getElementById('efOfGuideModal');
  if (!btn || !modal) return;
  var bodyEl = document.getElementById('efGuideBody');
  var progEl = document.getElementById('efGuideProgress');
  var backEl = document.getElementById('efGuideBack');
  var G = window.EF_GUIDE || { sizes: [], isVentless: false, currentTitle: '' };

  /* Real Fyre "Min. Fireplace Dimensions" — the firebox must be AT LEAST this big
     to fit each log-set size (front ≈ set + 12"). */
  var SPEC = [
    { set: 18, front: 30, rear: 18, depth: 12, height: 14 },
    { set: 24, front: 36, rear: 24, depth: 12, height: 14 },
    { set: 30, front: 42, rear: 30, depth: 14, height: 14 },
    { set: 36, front: 48, rear: 39, depth: 14, height: 14 },
    { set: 42, front: 54, rear: 45, depth: 14, height: 14 }
  ];
  function specFor(set) { for (var i = 0; i < SPEC.length; i++) if (SPEC[i].set === set) return SPEC[i]; return null; }

  var STEPS = [
    {
      key: 'width', q: 'How wide is your fireplace opening at the front?',
      help: 'Measure the front opening left-to-right. The log set sits about 12" narrower for safe clearance.',
      opts: [
        { label: '30 – 35 inches', sub: 'Fits an 18" set', val: 18 },
        { label: '36 – 41 inches', sub: 'Fits a 24" set', val: 24 },
        { label: '42 – 47 inches', sub: 'Fits a 30" set', val: 30 },
        { label: '48 – 53 inches', sub: 'Fits a 36" set', val: 36 },
        { label: '54 inches or wider', sub: 'Fits a 42" set', val: 42 },
        { label: 'Under 30 inches', sub: 'Narrower than a standard set', val: 0 }
      ]
    },
    {
      key: 'depth', q: 'How deep is your firebox, front to back?',
      help: 'Measure the floor from the front opening to the back wall. Bigger sets need a deeper firebox.',
      opts: [
        { label: '14 inches or deeper', sub: 'Fits every size', val: 14 },
        { label: '12 – 13 inches', sub: 'Fits up to a 24" set', val: 12 },
        { label: 'Under 12 inches', sub: 'Very shallow — limited options', val: 10 },
        { label: 'Not sure yet', sub: 'We’ll play it safe', val: 12 }
      ]
    },
    {
      key: 'vent', q: 'Does your fireplace have a working chimney?',
      help: 'A vented set needs an open flue & damper. Ventless needs no chimney.',
      opts: [
        { label: 'Yes — working chimney & flue', sub: 'The most realistic, tallest flame', val: 'vented' },
        { label: 'No chimney, or I want max heat', sub: 'Heats the room, very efficient', val: 'ventless' },
        { label: 'I’m not sure', sub: 'We’ll suggest the safe pick', val: 'vented' }
      ]
    },
    {
      key: 'control', q: 'How do you want to light & control the fire?',
      help: 'From the simplest to the most convenient.',
      opts: [
        { label: 'Keep it simplest & lowest cost', sub: 'Light it with a match', val: 'match' },
        { label: 'A safety knob I turn by hand', sub: 'Manual safety pilot', val: 'spk-26' },
        { label: 'Turn it on/off from the couch', sub: 'Remote control', val: 'apk-11' },
        { label: 'Adjust the flame height too', sub: 'Variable-flame remote', val: 'apk-15' },
        { label: 'Most efficient — no standing pilot', sub: 'Battery electronic ignition', val: 'epk-2' }
      ]
    }
  ];

  var IGN_INFO = {
    'match':  { name: 'Match Lit', why: 'Lowest cost — light it with a long match. No valve or battery.' },
    'spk-26': { name: 'Manual Safety Pilot (SPK-26)', why: 'A standing pilot with a safety shut-off knob you turn by hand.' },
    'apk-11': { name: 'On/Off Remote (APK-11)', why: 'Flip the fire on and off from your remote — no getting up.' },
    'apk-15': { name: 'Variable-Flame Remote (APK-15)', why: 'Remote on/off plus dial the flame height up or down.' },
    'epk-2':  { name: 'Electronic Ignition (EPK-2)', why: 'No standing pilot — battery ignition saves gas between uses.' }
  };
  var IGN_KW = { 'match': /match/i, 'spk-26': /manual|safety/i, 'apk-11': /on.?off/i, 'apk-15': /variable/i, 'epk-2': /electronic/i };

  var answers = {}; var idx = 0;

  function intSize(s) { var n = parseInt(String(s).replace(/[^0-9]/g, ''), 10); return isNaN(n) ? 0 : n; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* Largest log-set size allowed by the firebox width + depth (per RF chart). */
  function allowedSet() {
    var w = answers.width ? answers.width.val : 24;
    var d = answers.depth ? answers.depth.val : 12;
    if (!w) return { set: 0, tooNarrow: true };
    var depthMax = 0;
    SPEC.forEach(function (s) { if (s.depth <= d && s.set > depthMax) depthMax = s.set; });
    var set = Math.min(w, depthMax || 0);
    return { set: set, depthLimited: depthMax && set < w, tooShallow: d < 12, byWidth: w, byDepth: depthMax };
  }

  /* Map the allowed set to the nearest AVAILABLE product size (≤ allowed). */
  function pickAvailable(allowed) {
    var sizes = (G.sizes || []).map(function (s) { return { n: intSize(s.size), raw: s }; }).filter(function (s) { return s.n > 0; });
    if (!sizes.length) return null;
    sizes.sort(function (a, b) { return a.n - b.n; });
    var below = sizes.filter(function (s) { return s.n <= allowed; });
    var pick = below.length ? below[below.length - 1] : sizes[0];
    return pick.raw;
  }

  var returnFocus = null, previousOverflow = '';
  function focusQuestion() {
    var heading = bodyEl.querySelector('h2');
    if (heading) { heading.setAttribute('tabindex','-1'); heading.focus({preventScroll:true}); }
    var panel = modal.querySelector('.ef-of__guide-modal__panel'); if(panel)panel.scrollTop=0;
  }
  function open() {
    if (!modal.hidden) return;
    returnFocus = document.activeElement; previousOverflow = document.documentElement.style.overflow;
    idx = 0; answers = {}; modal.hidden = false; render(); document.documentElement.style.overflow = 'hidden'; focusQuestion();
  }
  function close() {
    modal.hidden = true; document.documentElement.style.overflow = previousOverflow;
    if(returnFocus && returnFocus.isConnected)returnFocus.focus({preventScroll:true});
  }

  function renderProgress(active, total) {
    if (!progEl) return;
    var h = '';
    for (var i = 0; i < total; i++) h += '<span class="ef-gq__dot' + (i <= active ? ' is-on' : '') + '"></span>';
    progEl.innerHTML = h;
  }

  function render() {
    if (idx >= STEPS.length) return renderResult();
    var step = STEPS[idx];
    renderProgress(idx, STEPS.length);
    if (backEl) backEl.hidden = idx === 0;
    var h = '<p class="ef-gq__step">Question ' + (idx + 1) + ' of ' + STEPS.length + '</p>';
    h += '<h2 class="ef-gq__q">' + esc(step.q) + '</h2>';
    h += '<p class="ef-gq__help">' + esc(step.help) + '</p>';
    h += '<div class="ef-gq__opts">';
    step.opts.forEach(function (o, i) {
      var sel = answers[step.key] && answers[step.key].label === o.label;
      h += '<button type="button" class="ef-gq__opt' + (sel ? ' is-sel' : '') + '" data-i="' + i + '">'
        + '<span class="ef-gq__opt-main">' + esc(o.label) + '</span>'
        + '<span class="ef-gq__opt-sub">' + esc(o.sub) + '</span>'
        + '<span class="ef-gq__opt-arrow" aria-hidden="true">→</span></button>';
    });
    h += '</div>';
    bodyEl.innerHTML = h;
    bodyEl.querySelectorAll('.ef-gq__opt').forEach(function (b) {
      b.addEventListener('click', function () { answers[step.key] = step.opts[+b.dataset.i]; idx++; render(); focusQuestion(); });
    });
  }

  function renderResult() {
    renderProgress(STEPS.length, STEPS.length);
    if (backEl) backEl.hidden = false;
    var rec = allowedSet();
    var sizeRaw = rec.set ? pickAvailable(rec.set) : pickAvailable(18);
    var recSet = sizeRaw ? intSize(sizeRaw.size) : rec.set;
    var spec = specFor(recSet) || specFor(24);
    var vent = answers.vent ? answers.vent.val : 'vented';
    var ignKey = answers.control ? answers.control.val : 'apk-11';
    var ign = IGN_INFO[ignKey] || IGN_INFO['apk-11'];
    var ventMismatch = (vent === 'ventless' && !G.isVentless) || (vent === 'vented' && G.isVentless);

    var sizeLabel = sizeRaw ? (recSet + '" set') : (recSet ? recSet + '" set' : 'This set');
    var sizePrice = sizeRaw && sizeRaw.price ? ' · $' + Math.round(sizeRaw.price) : '';
    var sizeIsCurrent = sizeRaw ? sizeRaw.current : true;

    var sizeDesc = sizeIsCurrent ? 'A safe fit for your firebox.' : 'Best fit for your firebox — one tap to switch to this size.';
    if (rec.depthLimited) sizeDesc = 'Sized to your firebox depth (a bigger set needs a deeper firebox).';

    var h = '<div class="ef-gq__result">';
    h += '<p class="ef-gq__step">Your perfect match</p>';
    h += '<h2 class="ef-gq__q">Here’s what we recommend</h2>';

    h += '<div class="ef-gq__rec">';
    h += card('Log set size', sizeLabel + sizePrice, sizeDesc, 'size');
    h += card('Fuel & venting', (vent === 'ventless' ? 'Ventless (Vent-Free)' : 'Vented'),
      vent === 'ventless' ? 'Heats the room with no chimney needed.' : 'The most realistic, full flame — uses your chimney.',
      ventMismatch ? 'vent-bad' : 'vent-ok');
    h += card('Ignition & control', ign.name, ign.why, 'ign');
    h += '</div>';

    /* Min-dimension fit check from the official chart — so we never mislead. */
    if (spec) {
      h += '<div class="ef-gq__fit">'
        + '<p class="ef-gq__fit-h">Make sure your fireplace is at least</p>'
        + '<div class="ef-gq__fit-grid">'
        + fit('Front width', spec.front + '"') + fit('Rear width', spec.rear + '"')
        + fit('Depth', spec.depth + '"') + fit('Height', spec.height + '"')
        + '</div></div>';
    }

    /* Warnings */
    if (rec.tooShallow) {
      h += note('Your firebox is under 12&quot; deep — standard vented sets need at least 12&quot;. '
        + '<a href="/collections/see-through-gas-logs">See our see-through &amp; shallow-firebox sets →</a>');
    }
    if (rec.tooNarrow) {
      h += note('Openings under 30&quot; are narrower than a standard set. Tell us your exact size and we’ll find a fit — '
        + '<a href="/pages/contact-us">contact our experts →</a>');
    }
    if (ventMismatch) {
      if (!G.isVentless) {
        /* Current product is VENTED, customer has no chimney */
        h += note('<strong>This is a Vented log set</strong> — it must have a <strong>working chimney with an open flue/damper</strong>. '
          + 'Your fireplace has no chimney, so this set won’t work for you. '
          + '<a href="/collections/ventless-gas-logs">Shop our Ventless (Vent-Free) sets — no chimney required →</a>');
      } else {
        /* Current product is VENTLESS, customer has a chimney */
        h += note('This is a <strong>Ventless</strong> set — no chimney required, and it works fine in your fireplace. '
          + 'Since you have a working chimney, you could also pick a Vented set for the tallest, most realistic flame. '
          + '<a href="/collections/vented-gas-logs">Browse Vented sets →</a>', 'ok');
      }
    }

    h += '<div class="ef-gq__actions">';
    if (G.collectionMode) {
      /* On a collection there's no configurator to apply to — send the shopper to the matching
         vent collection, pre-filtered to the recommended size (?size=&vent=). */
      var ventColl = vent === 'ventless' ? 'ventless-gas-logs' : 'vented-gas-logs';
      var ventName = vent === 'ventless' ? 'Ventless' : 'Vented';
      if (recSet && !rec.tooNarrow) h += '<a class="ef-gq__apply" style="display:block;text-align:center;text-decoration:none;" href="/collections/' + ventColl + '?size=' + recSet + '&vent=' + vent + '">Show ' + recSet + '&quot; ' + ventName + ' sets &rarr;</a>';
      else h += '<a class="ef-gq__apply" style="display:block;text-align:center;text-decoration:none;" href="/collections/' + ventColl + '">Browse ' + ventName + ' sets &rarr;</a>';
    } else {
      var canApply = !rec.tooNarrow && !(ventMismatch && !G.isVentless);
      if (canApply) h += '<button type="button" class="ef-gq__apply" id="efGuideApply" data-size="' + (recSet || '') + '" data-size-url="' + esc(sizeRaw && !sizeIsCurrent ? sizeRaw.url : '') + '" data-ign="' + ignKey + '">Apply to my build</button>';
    }
    h += '<button type="button" class="ef-gq__restart" id="efGuideRestart">Start over</button>';
    h += '</div></div>';
    bodyEl.innerHTML = h;

    var applyBtn = document.getElementById('efGuideApply');
    if (applyBtn) applyBtn.addEventListener('click', function () { applyRecommendation(applyBtn); });
    var restart = document.getElementById('efGuideRestart');
    if (restart) restart.addEventListener('click', function () { idx = 0; answers = {}; render(); focusQuestion(); });
  }

  function fit(label, val) {
    return '<div class="ef-gq__fit-cell"><span class="ef-gq__fit-val">' + esc(val) + '</span><span class="ef-gq__fit-lab">' + esc(label) + '</span></div>';
  }
  function note(html, kind) {
    return '<p class="ef-gq__note' + (kind === 'ok' ? ' ef-gq__note--ok' : '') + '">' + html + '</p>';
  }
  function card(kicker, title, desc, tag) {
    var icon = tag === 'vent-bad'
      ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#B45309" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/><path d="M12 9v4m0 4h.01"/></svg>'
      : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2F7A4A" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
    return '<div class="ef-gq__rec-row"><span class="ef-gq__rec-ic">' + icon + '</span>'
      + '<span class="ef-gq__rec-body"><span class="ef-gq__rec-kicker">' + esc(kicker) + '</span>'
      + '<span class="ef-gq__rec-title">' + esc(title) + '</span>'
      + '<span class="ef-gq__rec-desc">' + esc(desc) + '</span></span></div>';
  }

  /* Select the matching ignition card in the configurator. */
  function selectIgnition(ignKey) {
    var ignDetails = document.getElementById('efOfCd_ignition');
    if (!ignDetails) return false;
    ignDetails.open = true;
    var kw = IGN_KW[ignKey], hit = null;
    ignDetails.querySelectorAll('.ef-of__cd-opt').forEach(function (c) {
      var lab = (c.dataset.label || '') + ' ' + (c.dataset.rawLabel || '');
      if (!hit && kw && kw.test(lab)) hit = c;
    });
    if (hit) { hit.click(); return true; }
    return false;
  }

  function applyRecommendation(applyBtn) {
    var ignKey = applyBtn.dataset.ign, sizeInch = applyBtn.dataset.size, sizeUrl = applyBtn.dataset.sizeUrl;
    close();
    /* If the recommended size is a DIFFERENT product (size_siblings are separate products),
       NAVIGATE there so the size actually changes — carrying the ignition via ?ign=. */
    if (sizeUrl) {
      window.location.href = sizeUrl + (sizeUrl.indexOf('?') >= 0 ? '&' : '?') + 'ign=' + encodeURIComponent(ignKey);
      return;
    }
    /* Same size already → just select the ignition here + pulse the size pill. */
    selectIgnition(ignKey);
    setTimeout(function () {
      var sizeField = document.querySelector('.ef-of__field--gl-size');
      var match = null;
      document.querySelectorAll('.ef-of__field--gl-size .efg-size-thumb, .ef-of__field--gl-size .efg-size-pill').forEach(function (t) {
        var lab = (t.querySelector('.efg-size-thumb__label') || t).textContent || '';
        if (!match && new RegExp('\\b' + sizeInch + '\\b').test(lab)) match = t;
      });
      if (sizeField) sizeField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (match) { match.classList.add('ef-gq-pulse'); setTimeout(function () { match.classList.remove('ef-gq-pulse'); }, 2600); }
      toast('✓ Applied — ' + (sizeInch ? sizeInch + '" size + ' : '') + 'your ignition are set.');
    }, 150);
  }

  /* When we navigated here from "Apply" across a size change, the recommended ignition
     rides in ?ign= — select it once the configurator cards have rendered. */
  (function () {
    var m = (location.search || '').match(/[?&]ign=([^&]+)/);
    if (!m) return;
    var key = decodeURIComponent(m[1]);
    var tries = 0;
    var iv = setInterval(function () {
      var det = document.getElementById('efOfCd_ignition');
      if (det && det.querySelectorAll('.ef-of__cd-opt').length) {
        clearInterval(iv);
        if (selectIgnition(key)) { det.scrollIntoView({ behavior: 'smooth', block: 'center' }); toast('✓ Applied your recommended size & ignition.'); }
      } else if (++tries > 40) clearInterval(iv);
    }, 200);
  })();

  var toastWrap = null;
  function toast(msg, stack) {
    if (!toastWrap) { toastWrap = document.createElement('div'); toastWrap.className = 'ef-gq-toasts'; document.body.appendChild(toastWrap); }
    var t = document.createElement('div'); t.className = 'ef-gq-toast'; t.textContent = msg;
    toastWrap.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 300); }, 4200 + (stack ? 700 : 0));
  }

  btn.addEventListener('click', open);
  /* 2026-06-24 — collection pages open the quiz via any [data-gaslog-quiz] trigger
     ("Find My Best Fit"); the quiz then runs in collection mode (redirect, not apply). */
  document.addEventListener('click', function (e) { if (e.target.closest('[data-gaslog-quiz]')) { e.preventDefault(); open(); } });
  window.efOpenGaslogGuide = open;
  modal.addEventListener('click', function (e) { if (e.target.closest('[data-guide-close]')) close(); });
  if (backEl) backEl.addEventListener('click', function () { if (idx > 0) { idx--; render(); focusQuestion(); } });
  document.addEventListener('keydown', function (e) {
    if(modal.hidden)return;
    if(e.key==='Escape'){e.preventDefault();close();return;}
    if(e.key!=='Tab')return;
    var focusables=Array.prototype.slice.call(modal.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),[tabindex="0"]')).filter(function(el){return el.getClientRects().length && getComputedStyle(el).visibility!=='hidden';});
    if(!focusables.length)return;
    var first=focusables[0],last=focusables[focusables.length-1],current=document.activeElement;
    if(e.shiftKey&&(current===first||focusables.indexOf(current)<0)){e.preventDefault();last.focus();}
    else if(!e.shiftKey&&(current===last||focusables.indexOf(current)<0)){e.preventDefault();first.focus();}
  });
})();
